import Api from '../Api';

export const getAccessoryStocks = () => async dispatch => {
  const { data } = await Api.get('/accessory-inventory/stocks');

  dispatch({
    type: 'FETCH_ACCESSORY_STOCKS',
    payload: data,
  });
};

export const clearAccessoryStocks = () => {
  return {
    type: 'CLEAR_ACCESSORY_STOCKS',
  };
};

export const getAccessoryInventory = () => async dispatch => {
  const { data } = await Api.get('/accessory-inventory');

  dispatch({
    type: 'FETCH_ACCESSORY_INVENTORY',
    payload: data,
  });
};

export const clearAccessoryInventory = () => {
  return {
    type: 'CLEAR_ACCESSORY_INVENTORY',
  };
};

export const getAccessoryInventoryStats = () => async dispatch => {
  const { data } = await Api.get('/accessory-inventory/stats');

  dispatch({
    type: 'FETCH_ACCESSORY_INVENTORY_STATS',
    payload: data,
  });
};

export const clearAccessoryInventoryStats = () => {
  return {
    type: 'CLEAR_ACCESSORY_INVENTORY_STATS',
  };
};

export const getAccessoriesForJobchart = () => async dispatch => {
  const { data } = await Api.get('/accessory-inventory/accessoriesforjobchart');

  dispatch({
    type: 'FETCH_ACCESSORIES_FOR_JOBCHART',
    payload: data,
  });
};

export const clearAccessoriesForJobchart = () => {
  return {
    type: 'CLEAR_ACCESSORIES_FOR_JOBCHART',
  };
};

export const getSingleAccessoryInfo = id => async dispatch => {
  const { data } = await Api.get(`/accessory-inventory/${id}`);

  dispatch({
    type: 'FETCH_SINGLE_ACCESSORY_INFO',
    payload: data,
  });
};

export const clearSingleAccessoryInfo = () => {
  return {
    type: 'CLEAR_SINGLE_ACCESSORY_INFO',
  };
};

export const getSingleAccessoryInfoToTransfer = id => async dispatch => {
  const { data } = await Api.get(`/accessory-inventory/${id}/transfer`);

  dispatch({
    type: 'FETCH_SINGLE_ACCESSORY_INFO_TO_TRANSFER',
    payload: data,
  });
};

export const clearSingleAccessoryInfoToTransfer = () => {
  return {
    type: 'CLEAR_SINGLE_ACCESSORY_INFO_TO_TRANSFER',
  };
};

export const getAccessoryTransferHistory =
  accessoryInventoryId => async dispatch => {
    const { data } = await Api.get(
      `/accessory-inventory/transfer/list`,
      accessoryInventoryId
    );

    dispatch({
      type: 'FETCH_ACCESSORY_TRANSFER_HISTORY',
      payload: data,
    });
  };

export const clearAccessoryTransferHistory = () => {
  return {
    type: 'CLEAR_ACCESSORY_TRANSFER_HISTORY',
  };
};

export const getJobchartAccessoriesForRpo = jobchartId => async dispatch => {
  const { data } = await Api.get(
    `/accessory-inventory/jobchartAccessoriesforrpo/${jobchartId}`
  );

  dispatch({
    type: 'FETCH_JOBCHART_ACCESSORIES_FOR_RPO',
    payload: data,
  });
};

export const clearJobchartAccessoriesForRpo = () => {
  return {
    type: 'CLEAR_JOBCHART_ACCESSORIES_FOR_RPO',
  };
};

export const getAccessoriesStocksForOutward =
  (rpoId, params = {}) =>
  async dispatch => {
    const { data } = await Api.get(
      `/accessory-inventory/stocksforoutward/${rpoId}`,
      params
    );

    dispatch({
      type: 'FETCH_ACCESSORIES_STOCKS_FOR_OUTWARD',
      payload: data,
    });
  };

export const clearAccessoriesStocksForOutward = () => {
  return {
    type: 'CLEAR_ACCESSORIES_STOCKS_FOR_OUTWARD',
  };
};

export const getPendingAccessoryTransferRequestCount = () => async dispatch => {
  const { data } = await Api.get(`/accessory-inventory/pendingcount`);

  dispatch({
    type: 'FETCH_PENDING_ACCESSORY_TRANSFER_REQUEST_COUNT',
    payload: data,
  });
};

export const clearPendingAccessoryTransferRequestCount = () => ({
  type: 'CLEAR_PENDING_ACCESSORY_TRANSFER_REQUEST_COUNT',
});
